export const SHOW_SEARCH_FILTERS = 'SHOW_SEARCH_FILTERS';
export const HIDE_SEARCH_FILTERS = 'HIDE_SEARCH_FILTERS';

export const ACTIVATE_USER_FILTER_INTERACTION = 'ACTIVATE_USER_FILTER_INTERACTION';



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/constants.js